export const BASE_CHOWNOW_URL = 'https://get.chownow.com';
export const BASE_SUPPORT_URL = 'https://support.chownow.com';
const UTM_PARAMS =
  '?utm_source=product&utm_medium=orderdirect&utm_campaign=poweredbyfooter';
export const CHOWNOW_URL = `${BASE_CHOWNOW_URL}/${UTM_PARAMS}`;
// eslint-disable-next-line max-len
export const CANCELED_SUPPORT_URL = `${BASE_SUPPORT_URL}/customer/s/topic/0TO4A000000g8gzWAA/declined-canceled-orders`;
export const HELP_URL = `${BASE_SUPPORT_URL}/customer/s/`;
export const DOWNLOAD_APP_URL =
  'https://chownow.app.link/download-chownow-app-side-menu';

// BELOW TO BE USED FOR TESTING PURPOSES ONLY
// Use Manifest data for production
export const ITERABLE_PRIVACY_URL =
  'https://iterable.com/trust/privacy-policy/';
